
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import { l as labelsMixin } from './labels-mixin.js';
import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import PendoIcon from './pendo-icon.js';

var script = {
  name: 'PendoToggle',
  components: {
    PendoIcon
  },
  mixins: [labelsMixin],
  props: {
    value: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    activeIcon: {
      type: [Boolean, String],
      default: 'check'
    },
    inactiveIcon: {
      type: [Boolean, String],
      default: false
    }
  },
  computed: {
    icon() {
      if (this.value) {
        return this.activeIcon;
      }

      return this.inactiveIcon;
    }

  },
  methods: {
    toggle() {
      if (this.disabled) {
        return;
      }

      this.$emit('change', !this.value);
      this.$emit('input', !this.value);
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('label', {
    staticClass: "pendo-toggle",
    class: {
      'is-inline-label': !!_vm.inlineLabel,
      'is-checked': _vm.value,
      'is-disabled': _vm.disabled
    },
    attrs: {
      "role": "switch",
      "aria-checked": _vm.value,
      "aria-disabled": _vm.disabled
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
      }
    }
  }, [!!_vm.topLabel ? _c('div', {
    staticClass: "pendo-toggle__label pendo-toggle__label--top"
  }, [_vm._v("\n        " + _vm._s(_vm.topLabel) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "pendo-toggle__input",
    attrs: {
      "tabindex": "-1",
      "disabled": _vm.disabled,
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "keypress": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter") && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) {
          return null;
        }

        $event.preventDefault();
        return _vm.toggle($event);
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pendo-toggle__slide",
    attrs: {
      "tabindex": _vm.disabled ? -1 : 0
    },
    on: {
      "click": _vm.toggle,
      "keypress": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter") && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) {
          return null;
        }

        $event.preventDefault();
        return _vm.toggle($event);
      }
    }
  }, [_c('div', {
    staticClass: "pendo-toggle__inner"
  }, [_c('div', {
    staticClass: "pendo-toggle__handle"
  }), _vm._v(" "), _c('div', {
    staticClass: "pendo-toggle__icon"
  }, [_vm.icon ? _c('pendo-icon', {
    attrs: {
      "type": _vm.icon,
      "stroke-width": "3",
      "size": "14"
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), !!_vm.bottomLabel ? _c('div', {
    staticClass: "pendo-toggle__label pendo-toggle__label--bottom"
  }, [_vm._v("\n        " + _vm._s(_vm.bottomLabel) + "\n    ")]) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-toggle.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoToggle = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoToggle;
